// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageSectionElement_container__3Ppyv","alignRight":"ImageSectionElement_alignRight__3wpP4","alignLeft":"ImageSectionElement_alignLeft__38hTY"};